export { default as ProductsMaterialsFilterBadge } from './ProductsMaterialsFilterBadge';
